module.exports = __webpack_public_path__ + "static/robotgroup-044dc6ec85e32ef4a0abd058b4435252.png";